/* eslint-disable import/prefer-default-export */

export const EFFECTS_NOOP = Symbol('freactal effects noop');



// WEBPACK FOOTER //
// ./src/components/constants.js